import React, { useRef } from "react";
import SwitchInput from "common/SwitchInputWithState";
import { getFormData, rankAndParseFields } from "../utils";
import VLANs from "./VLANs";
import IPRanges from "./IPRanges";

const NetworksSettings = ({ onInputChange, defaults }) => (
  <>
    <h2 className="card-inside-title">Bypass by protocol</h2>
    <p>If enabled, the bypassed traffic will not get any optimization</p>
    <SwitchInput
      defaultChecked={defaults.ipv4}
      className={"sw-input"}
      name="ipv4"
      value={true}
      label="Bypass IPv4"
      onChange={onInputChange}
    />
    <SwitchInput
      defaultChecked={defaults.ipv6}
      className={"sw-input"}
      name="ipv6"
      value={true}
      label="Bypass IPv6"
      onChange={onInputChange}
    />
    <SwitchInput
      defaultChecked={defaults.mpls}
      className={"sw-input"}
      name="mpls"
      value={true}
      label="Bypass MPLS"
      onChange={onInputChange}
    />
    <SwitchInput
      defaultChecked={defaults.pppoe}
      className={"sw-input"}
      name="pppoe"
      value={true}
      label="Bypass PPPoE"
      onChange={onInputChange}
    />
  </>
);

const BypassSettings = ({ onChange, defaults = {}, state={} }) => {
  const form = useRef(null);
  const onInputChange = () => {
    const values = getFormData(form.current);
    onChange(rankAndParseFields(values, state));
  };
  const onVLANSChange = ({ list, untagged }) =>
    onChange({...state, vlans: list, untaggedVLANs: untagged });
  const onIPRangesChange = ({ list }) => onChange({ ipRanges: list });
  return (
    <>
      <form ref={form}>
        <NetworksSettings defaults={defaults} onInputChange={onInputChange} />
      </form>
      <VLANs
        defaults={{
          list: defaults.vlans,
          untagged: defaults.untaggedVLANs,
        }}
        onChange={onVLANSChange}
      />
      <IPRanges
        defaults={{
          list: defaults.ipRanges,
        }}
        onChange={onIPRangesChange}
      />
    </>
  );
};

export default BypassSettings;
